import type { DefaultMantineColor, MantineColorsTuple } from "@mantine/core";

type ExtendedCustomColors = "primary" | DefaultMantineColor;

declare module "@mantine/core" {
	export interface MantineThemeColorsOverride {
		colors: Record<ExtendedCustomColors, MantineColorsTuple>;
	}
}

export const PRIMARY_COLORS = [
	"#ebecff",
	"#d3d4ff",
	"#a3a5f8",
	"#7173f2",
	"#4749ed",
	"#2d2eeb",
	"#1e20eb",
	"#1015d1",
	"#0711bc",
	"#000da6",
] as const satisfies MantineColorsTuple;
